import config from '@/config';
import {ILang} from './type';

const list: ILang['list'] = [
    {
        tagName: 'Cámaras IP PoE & NVRs',
        link: `${config.store}/poe-ip-cameras/`
    },
    {
        tagName: 'Cámaras de doble lente',
        link: `${config.store}/dual-lens-cameras/`
    },
    {
        tagName: 'Video timbres',
        link: `${config.store}/video-doorbells/`
    },
    {
        tagName: 'Cámaras de seguridad WiFi',
        link: `${config.store}/wifi-security-cameras/`
    },
    {
        tagName: 'Cámaras alimentadas por batería',
        link: `${config.store}/battery-security-cameras/`
    },
    {
        tagName: 'Sistemas de cámara de seguridad',
        link: `${config.store}/security-camera-systems/`
    },
    {
        tagName: 'KEEN (Cámaras de rastreo)',
        link: `${config.official}/product/keen-ranger-pt/`
    },
];

const title: ILang['title'] = 'Construya su hogar Reolink seguro e inteligente';

export const es = {
    list,
    title
};
